import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from "react-bootstrap";
import { commonActionCall, handleShowShareModal } from '../../action';
import AnimButton from '../Button/AnimButton';
import { copyToClickboard } from '../../redux/reducers/utils';

const ShareModal = () => {
    const dispatch = useDispatch();
    const props = useSelector((state) => state.reducer);

    const socials = [
        {name: 'Email', icon: 'icon-mail-ico'},
        {name: 'Facebook', icon: 'icon-facebook-ico'},
        {name: 'Twitter', icon: 'icon-twitter-ico'},
        {name: 'LinkedIn', icon: 'icon-linkedIn-ico'}
    ]

    return (
        <Modal
            show={props.isShowShareModal}
            backdrop="static"
            keyboard={false}
            onHide={()=>dispatch(handleShowShareModal())}
            dialogClassName="share-modal react-modal"
            backdropClassName="ract-modal-pre-parent"
            centered
        >
            <Modal.Body>
                <div className='close' onClick={() => dispatch(handleShowShareModal())}>
                    <i className='icon-cross-ico'></i>
                </div>
                <div className='share-container'>
                    <div className='share-link-container'>
                        <div className='share-title'>Share</div>
                        <div className='share-item-container'>
                            {
                                socials.map((item, index) =>
                                    <div key={index} className='share-item'>
                                        <div className='share-item-icon'>
                                            <i className={item.icon}></i>
                                        </div>
                                        <div className='share-item-name'>{item.name}</div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <div className='share-action-container'>
                        <div className='copy-link-title'>
                            Copy Link from here
                            <i className='icon-copylink-ico'></i>
                        </div>
                        <div className='copy-link-container'>
                            <div className='copy-link' id="my-text-area">
                                https://crm.senseicrm.com/quotes/TUZKakdCelZISjRvZ1ZZTFBJVzhVZz09
                            </div>
                            <AnimButton className={'btn btn-primary'}
                                        event={(e) => {
                                                        copyToClickboard("innerHTML")
                                                        dispatch(commonActionCall(e.target.value,"change_share_text"))
                                                     }
                                              }
                                        >
                                            {props.copyShareText}
                            </AnimButton>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ShareModal
